module.exports = __webpack_public_path__ + "static/media/eight-tokens.a52db80b.svg";